import theme from "../../../../theme";

/**
 * Style object for the sidebar layout container.
 * Arranges all sidebar elements in a vertical stack.
 *
 * @type {import("@mui/system").SxProps}
 */
export const sidebarBox = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "0.5rem",
};

/**
 * Style object for the container of top action buttons.
 * Adds spacing between buttons and below the container.
 *
 * @type {import("@mui/system").SxProps}
 */
export const topButtonContainer = {
  display: "flex",
  flexDirection: "column",
  gap: "0.5rem",
  marginBottom: "1rem",
};

/**
 * Style object for sidebar action buttons ("Relist the Car", "Previous Auction 2").
 * Preserves all original props including padding, color, and hover behavior.
 *
 * @type {import("@mui/system").SxProps}
 */
export const sidebarButton = {
  border: `1px solid ${theme.palette.primary.main}`,
  borderRadius: "0.5rem",
  backgroundColor: "transparent",
  color: theme.palette.primary.main,
  textTransform: "none",
  fontWeight: 500,
  padding: "0.85rem 1rem",
  fontSize: "0.95rem",
  "&:hover": {
    backgroundColor: "transparent",
  },
};

/**
 * Style object for the Paper displaying sale information.
 *
 * @type {import("@mui/system").SxProps}
 */
export const saleInfoPaper = {
  padding: "1rem",
  borderRadius: "1rem",
  backgroundColor: theme.palette.background.paper,
};
